var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdditionalStop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.6211 8.45195C19.5711 3.83195 15.5411 1.75195 12.0011 1.75195C12.0011 1.75195 12.0011 1.75195 11.9911 1.75195C8.46107 1.75195 4.42107 3.82195 3.37107 8.44195C2.20107 13.602 5.36107 17.972 8.22107 20.722C9.28107 21.742 10.6411 22.252 12.0011 22.252C13.3611 22.252 14.7211 21.742 15.7711 20.722C18.6311 17.972 21.7911 13.612 20.6211 8.45195Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 13.4621C13.7413 13.4621 15.1516 12.0518 15.1516 10.3121C15.1516 8.57241 13.7413 7.16211 12.0016 7.16211C10.2619 7.16211 8.85156 8.57241 8.85156 10.3121C8.85156 12.0518 10.2619 13.4621 12.0016 13.4621Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalStop);
export default __webpack_public_path__ + "static/media/additional_stop.802765360dca106ad652de06fb53ec8d.svg";
export { ForwardRef as ReactComponent };